import { Box, Button, Typography } from "@mui/material";
import {
  renderEditActions,
  renderStopped,
  renderRelativeTimeWithTooltip,
  renderWithDateTooltip,
} from "components/DataTable/renderComponents";
import Severity from "components/Severity";
import UnitSerial from "components/Unit/UnitSerial";
import { DataTable } from "empower-energy-owner-components";
import { displayDurationBetweenDates } from "utils/datetime";
import NotificationModal from "./NotificationModal";
import { useState } from "react";
import { isNil } from "lodash";
import { AddCircleOutline } from "@mui/icons-material";
import UserBy from "components/UserPage/UserBy";

const NotificationList = ({
  loading,
  list,
  filters,
  onChangeFilters = undefined,
  totalCount,
  groupBy = false,
}) => {
  const [selectedNotification, setSelectNotification] = useState(null);

  const getColumns = () => {
    const columns = [
      {
        field: "unit",
        headerName: "Unit",
        width: 120,
        renderCell: (params) => <UnitSerial id={params.value} />,
      },
      {
        field: "event",
        headerName: "Event",
        width: 200,
      },
      {
        field: "message",
        headerName: "Message",
        minWidth: 200,
        flex: 1,
      },
      {
        field: "severity",
        headerName: "Severity",
        width: 100,
        renderCell: (params) => <Severity severity={params.value} />,
      },
      {
        field: "set",
        headerName: "Started",
        width: 100,
        renderCell: (params) =>
          renderRelativeTimeWithTooltip(params.value * 1000),
      },
      {
        field: "clear",
        headerName: "Stopped",
        width: 80,
        renderCell: (params) =>
          renderWithDateTooltip(params.value * 1000, renderStopped(params.row)),
      },
      {
        field: "duration",
        headerName: "Duration",
        width: 160,
        renderCell: (params) =>
          params.row.clear
            ? displayDurationBetweenDates(
                params.row.set * 1000,
                params.row.clear * 1000,
              )
            : "",
      },
      {
        field: "acknowledged",
        headerName: "Acknowledged",
        renderCell: (params) =>
          renderRelativeTimeWithTooltip(params.value * 1000),
      },
      {
        field: "acknowledged_by",
        headerName: "Ack. By",
        width: 180,
        renderCell: (params) => <UserBy id={params.value} />,
      },
      {
        field: "closed",
        headerName: "Closed",
        renderCell: (params) =>
          renderRelativeTimeWithTooltip(params.value * 1000),
      },
      {
        field: "id",
        width: "100",
        headerName: "Actions",
        align: "right",
        headerAlign: "right",
        renderCell: (params) => renderEditActions(params, onClickEdit),
      },
    ];

    if (groupBy) {
      columns.unshift({
        field: "items",
        headerName: "Occurances",
        width: 100,
        renderCell: renderOccurances,
      });
    }

    return columns;
  };

  const renderOccurances = (params) => {
    return (
      <Button
        startIcon={<AddCircleOutline />}
        onClick={() => onClickEdit(params.row)}
      >
        <Typography variant="subtitle2">{params.row.items.length}</Typography>
      </Button>
    );
  };

  const onClickEdit = (item) => {
    setSelectNotification(item);
  };

  const getMoreOptions = () => {
    if (filters && filters?.paginationModel && filters?.sortModel) {
      return {
        paginationMode: "server",
        paginationModel: filters?.paginationModel,
        setPaginationModel: (e) => onChangeFilters({ paginationModel: e }),
        sortingMode: "server",
        sortModel: filters?.sortModel,
        setSortModel: (e) => onChangeFilters({ sortModel: e }),
        totalCount: totalCount,
      };
    }
  };

  return (
    <Box>
      <DataTable
        rows={list}
        columns={getColumns()}
        loading={loading}
        {...getMoreOptions()}
      />

      {!isNil(selectedNotification) && (
        <NotificationModal
          open={true}
          notification={selectedNotification}
          onClose={(refresh) => {
            setSelectNotification(null);
            if (refresh) {
              onChangeFilters(filters);
            }
          }}
          groupBy={groupBy}
        />
      )}
    </Box>
  );
};

export default NotificationList;
